document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('add-design');
  const DESIGN_VARIANT_ID = 42670566539341;
  const MAIN_PRODUCT_HANDLE = 'credencial';

  const productForm = document.querySelector('product-form');
  if (!productForm || !checkbox) return;

  const button = productForm.querySelector('button[name="add"]');
  if (!button) return;

  button.addEventListener('click', async (e) => {
    if (!checkbox.checked) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const form = productForm.querySelector('form');
    const formData = new FormData(form);
    // 1. Añadir producto principal
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    // 2. Evitar duplicados
    const cart = await fetch('/cart.js').then(r => r.json());

    if (!cart.items.some(i => i.variant_id === DESIGN_VARIANT_ID)) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: DESIGN_VARIANT_ID,
          quantity: 1
        })
      });
    }

    // 3. Refrescar y abrir banner de carrito
    await refreshCartDrawer();

    // 4. Refrescar contador de productos en carrito de header
    await updateCartCount();
  });
});

